<template>
    <!--
            描述：菜品-菜品扩展
        -->
    <div className="common-seach-wrap">
        <Sales v-if="activeName === 'sales'"></Sales>
        <User v-if="activeName === 'user'"></User>
        <Statisticsorder v-if="activeName === 'statisticsorder'"></Statisticsorder>
        <Product v-if="activeName === 'product'"></Product>
    </div>
</template>
<script>
import bus from '@/utils/eventBus.js';

import Sales from "./sales/index";
import User from "./user/index";
import Statisticsorder from "./statisticsorder/index";
import Product from "./product/index";

export default {
    components: {
        Sales,
        User,
        Statisticsorder,
        Product,
    },
    data() {
        return {
            /*是否加载完成*/
            loading: true,
            form: {},
            /*参数*/
            param: {},
            /*当前选中*/
            activeName: 'settled',
            /*切换数组原始数据*/
            sourceList: [
                {
                    key: 'sales',
                    value: this.$t('销售统计'),
                    path: '/datastatistics/statistics/sales/index'
                },
                {
                    key: 'user',
                    value: this.$t('会员统计'),
                    path: '/datastatistics/statistics/user/index'
                },
                {
                    key: 'statisticsorder',
                    value: this.$t('订单概况'),
                    path: '/datastatistics/statistics/statisticsorder/index'
                },
                {
                    key: 'product',
                    value: this.$t('菜品概况'),
                    path: '/datastatistics/statistics/product/index'
                },
            ],
            /*权限筛选后的数据*/
            tabList: [],
        };
    },
    watch: {
        //监听路由
        $route(to, from) {
            this.init();
        }
    },
    mounted() {
        this.init()
    },
    beforeDestroy() {
        //发送类别切换
        bus.$emit('tabData', {active: null, tab_type: 'expand', list: []});
        bus.$off('activeValue');
    },
    methods: {
        /*初始化方法*/
        init() {
            this.tabList = this.authFilter();

            if (this.tabList.length > 0) {
                this.activeName = this.tabList[0].key;
            }

            if (this.$route.query.type != null) {
                this.activeName = this.$route.query.type;
            }

            /*监听传插件的值*/
            bus.$on('activeValue', res => {
                if (this.is_third_param) {
                    this.param.user_id = '';
                    this.is_third_param = false;
                }
                this.activeName = res;
            });

            //发送类别切换
            let params = {
                active: this.activeName,
                list: this.tabList,
                tab_type: 'expand'
            };
            bus.$emit('tabData', params);
        },
        /*权限过滤*/
        authFilter() {
            let list = [];
            for (let i = 0; i < this.sourceList.length; i++) {
                let item = this.sourceList[i];
                if (this.$filter.isAuth(item.path)) {
                    list.push(item);
                }
            }
            return list;
        },
    }
};
</script>

<style>
.operation-wrap {
    height: 124px;
    border-radius: 8px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 30px 30px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
    background: #909399;
    background-size: 100% 100%;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/datastatistics/statistics/index.vue